module.exports = __webpack_public_path__ + "img/offer_0.ec01d386.svg";